import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "37",
  height: "49",
  fill: "none",
  viewBox: "0 0 37 49"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#C7596B",
      d: "M7.81 43.963c-2.203-2.504-4.406-5.107-5.808-8.212C.6 32.447.199 28.641.9 25.036s2.304-7.01 4.607-9.914c-.2 2.504.701 5.107 2.403 7.01-1.001-4.807.601-10.014 3.806-13.82 3.204-3.805 7.61-6.309 12.217-8.011-2.303 2.403-2.603 6.209-1.702 9.413s2.804 6.009 4.506 8.913 3.305 5.908 3.405 9.213c.902-1.702 1.903-3.405 2.504-5.308.6-1.902.901-3.905.4-5.808 1.803 2.203 2.804 4.407 3.305 7.21.5 2.804.4 5.709.1 8.513-.4 3.104-1.201 6.309-2.904 8.912-2.003 3.105-5.207 5.308-8.712 6.51-6.21 1.101-12.318.2-17.025-3.906"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#F9F0B0",
      d: "M15.421 47.668c8.212 3.205 16.323-6.51 11.817-14.02 0-.1-.1-.1-.1-.2.4 4.106-.601 7.11-2.504 8.812 1.002-2.403.3-5.207-.901-7.61-1.202-2.304-2.904-4.407-4.206-6.61-1.302-2.303-2.303-4.907-1.703-7.51-2.403 1.802-4.105 4.506-4.806 7.41-.702 2.904-.3 6.109 1.001 8.812-1.502-1.101-2.604-2.904-2.704-4.806-1.602 1.902-2.604 4.406-2.503 6.91 0 3.905 3.104 7.41 6.61 8.812"
    }, null, -1)
  ])))
}
export default { render: render }